import { c as _c } from "react/compiler-runtime";
import { Choice, Switch } from 'platform/components';
import { match } from 'ts-pattern';
import type { FeGridSettings } from '../../../../types/Api';
import type { LineHeight } from '../../../../utils/lineHeightToValue';
export type SettingsPanelProps = {
  settings: FeGridSettings;
  onSettingsChange: (settings: Partial<FeGridSettings>) => void;
};
type HeightOption = {
  value: LineHeight;
  label: string;
};
type PageSizeOption = {
  value: number;
  label: string;
};
const ROW_HEIGHT_OPTIONS: HeightOption[] = [{
  value: 'COMPACT',
  label: 'Compact'
}, {
  value: 'SHORT',
  label: 'Small'
}, {
  value: 'DEFAULT',
  label: 'Default'
}, {
  value: 'TALL',
  label: 'Tall'
}, {
  value: 'THUMBNAIL',
  label: 'Thumbnail'
}];
const HEADER_HEIGHT_OPTIONS: HeightOption[] = [{
  value: 'COMPACT',
  label: 'Compact'
}, {
  value: 'SHORT',
  label: 'Small'
}, {
  value: 'DEFAULT',
  label: 'Default'
}, {
  value: 'TALL',
  label: 'Tall'
}, {
  value: 'THUMBNAIL',
  label: 'Thumbnail'
}];
const PAGE_SIZE_OPTIONS: PageSizeOption[] = [{
  value: 25,
  label: '25'
}, {
  value: 50,
  label: '50'
}, {
  value: 75,
  label: '75'
}, {
  value: 100,
  label: '100'
}, {
  value: 200,
  label: '200'
}];
export function SettingsPanel(props) {
  const $ = _c(43);
  let t0;
  if ($[0] !== props) {
    t0 = value => {
      const heightValue = match(value).with("COMPACT", _temp).with("SHORT", _temp2).with("DEFAULT", _temp3).with("TALL", _temp4).with("THUMBNAIL", _temp5).otherwise(() => props.settings.rowHeight);
      props.onSettingsChange({
        rowHeight: heightValue
      });
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleRowHeightChange = t0;
  let t1;
  if ($[2] !== props) {
    t1 = value_0 => {
      const heightValue_0 = match(value_0).with("COMPACT", _temp6).with("SHORT", _temp7).with("DEFAULT", _temp8).with("TALL", _temp9).with("THUMBNAIL", _temp0).otherwise(() => props.settings.headerHeight);
      props.onSettingsChange({
        headerHeight: heightValue_0
      });
    };
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleHeaderHeightChange = t1;
  let t2;
  if ($[4] !== props) {
    t2 = value_1 => {
      const numValue = typeof value_1 === "number" ? value_1 : Number(value_1);
      props.onSettingsChange({
        itemsPerPage: isNaN(numValue) ? 25 : numValue
      });
    };
    $[4] = props;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handlePageSizeChange = t2;
  let t3;
  if ($[6] !== props) {
    t3 = value_2 => {
      props.onSettingsChange({
        stripedRows: value_2
      });
    };
    $[6] = props;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleZebraChange = t3;
  let t4;
  if ($[8] !== props) {
    t4 = value_3 => {
      props.onSettingsChange({
        horizontalSeparatorsVisible: value_3
      });
    };
    $[8] = props;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleHorizontalSeparatorsChange = t4;
  let t5;
  if ($[10] !== props) {
    t5 = value_4 => {
      props.onSettingsChange({
        verticalSeparatorsVisible: value_4
      });
    };
    $[10] = props;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleVerticalSeparatorsChange = t5;
  let t6;
  if ($[12] !== props) {
    t6 = value_5 => {
      props.onSettingsChange({
        columnGroupsVisible: value_5
      });
    };
    $[12] = props;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const handleColumnGroupsChange = t6;
  let t7;
  if ($[14] !== handleHeaderHeightChange || $[15] !== props.settings.headerHeight) {
    t7 = <Choice label="Header height" name="headerHeight" options={HEADER_HEIGHT_OPTIONS} value={props.settings.headerHeight} onChange={handleHeaderHeightChange} isNotClearable={true} />;
    $[14] = handleHeaderHeightChange;
    $[15] = props.settings.headerHeight;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== handleRowHeightChange || $[18] !== props.settings.rowHeight) {
    t8 = <Choice label="Row height" name="rowHeight" options={ROW_HEIGHT_OPTIONS} value={props.settings.rowHeight} onChange={handleRowHeightChange} isNotClearable={true} />;
    $[17] = handleRowHeightChange;
    $[18] = props.settings.rowHeight;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== handlePageSizeChange || $[21] !== props.settings.itemsPerPage) {
    t9 = <Choice label="Items per page" name="itemsPerPage" options={PAGE_SIZE_OPTIONS} value={props.settings.itemsPerPage} onChange={handlePageSizeChange} isNotClearable={true} />;
    $[20] = handlePageSizeChange;
    $[21] = props.settings.itemsPerPage;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== handleZebraChange || $[24] !== props.settings.stripedRows) {
    t10 = <Switch label="Zebra striping" value={props.settings.stripedRows} onChange={handleZebraChange} />;
    $[23] = handleZebraChange;
    $[24] = props.settings.stripedRows;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== handleHorizontalSeparatorsChange || $[27] !== props.settings.horizontalSeparatorsVisible) {
    t11 = <Switch label="Horizontal separators" value={props.settings.horizontalSeparatorsVisible} onChange={handleHorizontalSeparatorsChange} />;
    $[26] = handleHorizontalSeparatorsChange;
    $[27] = props.settings.horizontalSeparatorsVisible;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== handleVerticalSeparatorsChange || $[30] !== props.settings.verticalSeparatorsVisible) {
    t12 = <Switch label="Vertical separators" value={props.settings.verticalSeparatorsVisible} onChange={handleVerticalSeparatorsChange} />;
    $[29] = handleVerticalSeparatorsChange;
    $[30] = props.settings.verticalSeparatorsVisible;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== handleColumnGroupsChange || $[33] !== props.settings.columnGroupsVisible) {
    t13 = <Switch label="Column groups" value={props.settings.columnGroupsVisible} onChange={handleColumnGroupsChange} />;
    $[32] = handleColumnGroupsChange;
    $[33] = props.settings.columnGroupsVisible;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t10 || $[36] !== t11 || $[37] !== t12 || $[38] !== t13 || $[39] !== t7 || $[40] !== t8 || $[41] !== t9) {
    t14 = <div className="flex flex-col h-full overflow-hidden"><div className="flex flex-col gap-4 p-4 overflow-y-auto flex-1">{t7}{t8}{t9}{t10}{t11}{t12}{t13}</div></div>;
    $[35] = t10;
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
    $[39] = t7;
    $[40] = t8;
    $[41] = t9;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  return t14;
}
function _temp0() {
  return "THUMBNAIL" as LineHeight;
}
function _temp9() {
  return "TALL" as LineHeight;
}
function _temp8() {
  return "DEFAULT" as LineHeight;
}
function _temp7() {
  return "SHORT" as LineHeight;
}
function _temp6() {
  return "COMPACT" as LineHeight;
}
function _temp5() {
  return "THUMBNAIL" as LineHeight;
}
function _temp4() {
  return "TALL" as LineHeight;
}
function _temp3() {
  return "DEFAULT" as LineHeight;
}
function _temp2() {
  return "SHORT" as LineHeight;
}
function _temp() {
  return "COMPACT" as LineHeight;
}